import React from 'react';
import styled from 'styled-components';
import { Modal } from 'semantic-ui-react';
import Text from "new_components/atoms/Text";
import { MiniILIcon, UserAvatar as UserIcon } from "app/audit/simple/components/Icons";
import colors from "styles/colors";
import typography from "styles/typography";
import { ILIcon } from "./Icons";
import IconContainer from "./IconContainer";
import { closeIcon } from "components/Icons";


const ModalContent = styled.div`
  padding: 20px;
  height: 90vh;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 6px;
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    &:hover {
      background-color: rgba(0, 0, 0, 0.2);
    }
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;

const ConversationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding-right: 10px;
  &::-webkit-scrollbar {
    width: 6px;
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    &:hover {
      background-color: rgba(0, 0, 0, 0.2);
    }
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;

const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  background-color: ${props => props.isAI ? '#f8faff' : '#f8faff'};
  border-radius: 8px;
  position: relative;
  max-width: 70%;
  align-self: ${props => props.isAI ? 'flex-start' : 'flex-end'};
  margin-left: ${props => props.isAI ? '48px' : '0'};
  margin-right: ${props => props.isAI ? '0' : '48px'};
`;

const MessageContent = styled.div`
  padding-left: 24px;
`;

const QuestionText = styled(Text)`
  color: ${colors.neutral[900]};
  font-weight: 600;
`;

const IconWrapper = styled.div`
  position: absolute;
  ${props => props.isAI ? 'left: -40px;' : 'right: -40px;'}
  top: 4px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.isAI ? '#2D70E2' : '#f8faff'};
  border-radius: 6px;
  border: none;
`;

const FollowupQuestion = styled(Text)`
  color: ${colors.neutral[900]};
  font-size: 14px;
`;

const AIHeader = styled(Text)`
  color: ${colors.primary[500]} !important;
  padding-left: 22px;
  font-size: 13px;
`;

const QuestionWrapper = styled.div`
  padding: 16px;
  background-color: #f8faff;
  border-radius: 8px;
  margin-bottom: 16px;
  justify-content: center;
  align-items: center;
  display: flex;
`;

const TopSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const T2 = styled.div`
  font-family: Raleway;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 128%;
  color: #2a3039;
`;

const ScoreSection = styled.div`
  font-size: 14px;
  color: #666d79;
  margin-bottom: 12px;
`;

const ScoreLabel = styled.span`
  font-weight: 600;
  color: #2a3039;
`;

const FeedbackSection = styled.div`
  margin-top: 12px;
`;

const FeedbackLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #2a3039;
  margin-bottom: 8px;
`;

const FeedbackText = styled.div`
  font-size: 14px;
  color: #666d79;
  line-height: 1.5;
`;

const MessageHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const QuestionTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #2a3039;
  line-height: 1.2;
`;

const CloseButton = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
`;

const ConversationModal = ({ open, onClose, conversation }) => {
    if (!conversation) return null;

    return (
        <Modal
            open={open}
            onClose={onClose}
            size="small"
            closeIcon={false}
        >
            <ModalContent>
                <TopSection>
                    <T2>Conversation</T2>
                    <CloseButton onClick={onClose}>
                        {closeIcon("#2A3039")}
                    </CloseButton>
                </TopSection>

                <QuestionWrapper>
                    <QuestionTitle>{conversation.question}</QuestionTitle>
                </QuestionWrapper>

                <ConversationWrapper>
                    {/* Main Response */}
                    <MessageWrapper>
                        <IconWrapper>
                            <IconContainer icon={UserIcon("#FFF")} />
                        </IconWrapper>
                        <MessageContent>
                            <Text typographyStyle={typography.caption.regular}>
                                {conversation.mainResponse}
                            </Text>
                        </MessageContent>
                    </MessageWrapper>

                    {/* Follow-up Section */}
                    {conversation.followUp && (
                        <>
                            <MessageWrapper isAI>
                                <IconWrapper isAI>
                                    <IconContainer backgroundColor="#2D70E2" icon={ILIcon("#FFF")} />
                                </IconWrapper>
                                <MessageHeader>
                                    <AIHeader typographyStyle={typography.smallText.semibold}>
                                        Innerlogic AI Follow up
                                    </AIHeader>
                                </MessageHeader>
                                <MessageContent>
                                    <FollowupQuestion typographyStyle={typography.caption.regular}>
                                        {conversation.followUpQuestion}
                                    </FollowupQuestion>
                                </MessageContent>
                            </MessageWrapper>

                            <MessageWrapper>
                                <IconWrapper>
                                    <IconContainer icon={UserIcon("#FFF")} />
                                </IconWrapper>
                                <MessageContent>
                                    <Text typographyStyle={typography.caption.regular}>
                                        {conversation.followUp}
                                    </Text>
                                </MessageContent>
                            </MessageWrapper>
                        </>
                    )}
                </ConversationWrapper>
            </ModalContent>
        </Modal>
    );
};

export default ConversationModal; 